export const PATIENT_FLAGS = [
  'alertFlag',
  'allergyFlag',
  'catastrophicIllnessFlag',
  'dnrFlag',
] as const;
